"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsonpathPlus = require("jsonpath-plus");
var _r10CommonComponents = require("r10-common-components");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable max-len */
var ExtractAddonsData = /*#__PURE__*/function () {
  function ExtractAddonsData(addons, eligibleAddonKeys) {
    var socialAppsPriority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var inclusionIcons = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, ExtractAddonsData);
    this.addons = addons;
    this.keys = eligibleAddonKeys;
    this.socialAppsPriority = socialAppsPriority;
    this.inclusionIcons = inclusionIcons;
  }
  _createClass(ExtractAddonsData, [{
    key: "getValueCorrespondingToData",
    value: function getValueCorrespondingToData(key) {
      return "$[*].productSpecCharacteristic[?(@.name=== '".concat(key, "')].productSpecCharacteristicValue[*].value");
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      var categoryPath = this.keys.categoryPath;
      var allCategories = (0, _jsonpathPlus.JSONPath)(categoryPath, this.addons);
      var uniqueCategories = _toConsumableArray(new Set(allCategories));
      return uniqueCategories;
    }
  }, {
    key: "getCategory",
    value: function getCategory(category) {
      return "$.subCategory[?(@.id==='".concat(category, "')].productOffering[*]");
    }
  }, {
    key: "getProductSpecCharacteristicObject",
    value: function getProductSpecCharacteristicObject(condition) {
      return "$.productSpecification.productSpecCharacteristic[?(@.".concat(condition, ")]");
    }
  }, {
    key: "getTopFeatureText",
    value: function getTopFeatureText(feature, categoriesAddonsPath) {
      var _JSONPath$ = (0, _jsonpathPlus.JSONPath)("$[*].productSpecCharacteristic[?(@.name=== '".concat(feature, "')].productSpecCharacteristicValue[0]"), categoriesAddonsPath)[0],
        value = _JSONPath$.value,
        unitOfMeasure = _JSONPath$.unitOfMeasure;
      return {
        feature: feature,
        value: value,
        unitOfMeasure: unitOfMeasure
      };
    }
  }, {
    key: "getServicesIncluded",
    value: function getServicesIncluded(category, supportedAppsKey) {
      var categoryPath = this.getCategory(category);
      var path = this.getProductSpecCharacteristicObject("name==='".concat(supportedAppsKey, "'"));
      var categoryData = (0, _jsonpathPlus.JSONPath)(categoryPath, this.addons);
      var servicesIncluded = {};
      var socialAppsPriorityObject = this.socialAppsPriority.reduce(function (acc, app) {
        acc = _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, app.name.toLowerCase(), {
          icon: app.icon.toLowerCase(),
          priority: app.priority
        }));
        return acc;
      }, {});
      categoryData.forEach(function (addon) {
        var targetData = (0, _jsonpathPlus.JSONPath)(path, addon);
        var formattedTargetData = targetData.map(function (item) {
          return item.productSpecCharacteristicValue.reduce(function (acc, app) {
            var socialApp = app.value.trim();
            acc.push(_objectSpread({
              name: socialApp,
              icon: socialApp.toLowerCase(),
              priority: 1000
            }, socialAppsPriorityObject[socialApp.toLowerCase()]));
            return acc;
          }, []).sort(function (a, b) {
            return a.priority - b.priority;
          });
        })[0];
        servicesIncluded = _objectSpread(_objectSpread({}, servicesIncluded), {}, _defineProperty({}, addon.id, targetData.length ? formattedTargetData.filter(function (app) {
          return (app === null || app === void 0 ? void 0 : app.icon) !== 'null' && (app === null || app === void 0 ? void 0 : app.icon) !== null;
        }) : []));
      });
      return servicesIncluded;
    }
  }, {
    key: "getTopFeatures",
    value: function getTopFeatures(category) {
      var _this = this;
      var inclusionsKey = this.keys.inclusionsKey;
      var categoryPath = this.getCategory(category);
      var path = this.getProductSpecCharacteristicObject(inclusionsKey);
      var categoryData = (0, _jsonpathPlus.JSONPath)(categoryPath, this.addons);
      var topFeatures = {};
      categoryData.forEach(function (addon) {
        var targetData = (0, _jsonpathPlus.JSONPath)(path, addon);
        var formattedTargetData = targetData.map(function (item) {
          var _this$inclusionIcons$;
          var iconName = ((_this$inclusionIcons$ = _this.inclusionIcons.find(function (inclusion) {
            return inclusion.name.toLowerCase() === item.name.toLowerCase();
          })) === null || _this$inclusionIcons$ === void 0 ? void 0 : _this$inclusionIcons$.icon) || 'add-ons';
          return {
            feature: item.name.toLowerCase(),
            value: item.productSpecCharacteristicValue[0].value,
            unitOfMeasure: item.productSpecCharacteristicValue[0].unitOfMeasure,
            iconName: iconName
          };
        });
        topFeatures = _objectSpread(_objectSpread({}, topFeatures), {}, _defineProperty({}, addon.id, formattedTargetData));
      });
      return topFeatures;
    }
  }, {
    key: "getRenewAndValidity",
    value: function getRenewAndValidity(category) {
      var renewAndValidityKey = this.keys.renewAndValidityKey;
      var categoryPath = this.getCategory(category);
      var path = "$.".concat(renewAndValidityKey, "[*]");
      var categoryData = (0, _jsonpathPlus.JSONPath)(categoryPath, this.addons);
      var renewAndValidity = {};
      categoryData.forEach(function (addon) {
        var targetData = (0, _jsonpathPlus.JSONPath)(path, addon);
        var addonTypes = targetData.map(function (i) {
          var text = i.productSpecCharacteristicValue[0].value;
          return text.toLowerCase();
        });
        renewAndValidity = _objectSpread(_objectSpread({}, renewAndValidity), {}, _defineProperty({}, addon.id, {
          text: addonTypes.join('/'),
          showToggleButton: addonTypes.length > 1,
          addonTypes: addonTypes
        }));
      });
      return renewAndValidity;
    }
  }, {
    key: "getCategoriesAndItsAddons",
    value: function getCategoriesAndItsAddons() {
      var _this2 = this;
      var categorizedAddons = {};
      var _this$keys = this.keys,
        nameKey = _this$keys.nameKey,
        supportedAppsKey = _this$keys.supportedAppsKey,
        durationKey = _this$keys.durationKey,
        priceKey = _this$keys.priceKey;
      var categoriesList = this.getCategories();
      categoriesList.forEach(function (category) {
        var categoryPath = _this2.getCategory(category);
        var categoryAddonSpecsPath = "".concat(categoryPath, ".productSpecification");
        var categoriesAddonsPath = (0, _jsonpathPlus.JSONPath)(categoryAddonSpecsPath, _this2.addons);
        var ids = (0, _jsonpathPlus.JSONPath)('$[*].id', categoriesAddonsPath);
        var names = (0, _jsonpathPlus.JSONPath)(nameKey, categoriesAddonsPath);
        var durationPath = "".concat(categoryPath, ".").concat(durationKey, "[*]");
        var durations = (0, _jsonpathPlus.JSONPath)(durationPath, _this2.addons).map(function (item) {
          return item.duration ? "".concat(item.duration.amount, " ").concat(item.duration.units) : item.description;
        });
        var topFeatures = _this2.getTopFeatures(category);
        var servicesIncluded = _this2.getServicesIncluded(category, supportedAppsKey);
        var pricePath = "".concat(categoryPath, ".").concat(priceKey, "[*].price");
        var prices = (0, _jsonpathPlus.JSONPath)(pricePath, _this2.addons);
        var formattedPrices = prices.map(function (price) {
          var _utils$formatMoney = _r10CommonComponents.utils.formatMoney(price.value, price.unit, true),
            money = _utils$formatMoney.money,
            currencySymbol = _utils$formatMoney.currencySymbol;
          return {
            price: price,
            formattedPrice: "".concat(money).concat(currencySymbol)
          };
        });
        var renewAndValidity = _this2.getRenewAndValidity(category);
        names.forEach(function (item, i) {
          var _servicesIncluded$ids;
          var existingCategory = categorizedAddons[category] || [];
          var apps = Object.keys(servicesIncluded).length && (_servicesIncluded$ids = servicesIncluded[ids[i]]) !== null && _servicesIncluded$ids !== void 0 && _servicesIncluded$ids.length ? servicesIncluded[ids[i]] : [];
          categorizedAddons = _objectSpread(_objectSpread({}, categorizedAddons), {}, _defineProperty({}, category, [].concat(_toConsumableArray(existingCategory), [{
            name: item,
            id: ids[i],
            price: formattedPrices[i],
            duration: durations[i],
            topFeatures: topFeatures[ids[i]],
            category: category,
            servicesIncluded: apps,
            renewAndValidity: renewAndValidity[ids[i]]
          }])));
        });
      });
      return categorizedAddons;
    }
  }]);
  return ExtractAddonsData;
}();
exports.default = ExtractAddonsData;